import { render } from "./Candidates.vue?vue&type=template&id=b3adef5c&scoped=true"
import script from "./Candidates.vue?vue&type=script&lang=js"
export * from "./Candidates.vue?vue&type=script&lang=js"

import "./Candidates.vue?vue&type=style&index=0&id=b3adef5c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b3adef5c"

export default script